export const BCRYPT_SALT_LENGTH = 13;
export const MINIMUM_PASSWORD_LENGTH = 8;
export const EMAIL_VERIFICATION_EXPIRY_HOURS = 24;
export const EMAIL_CHANGE_EXPIRY_HOURS = 6;
export const PASSWORD_RESET_EXPIRY_HOURS = 6;
export const TOTP_AND_RECOVERY_CODES_EXPIRY_MINUTES = 12;
